import { render, staticRenderFns } from "./CustomerListItem.vue?vue&type=template&id=45a3f71b"
import script from "./CustomerListItem.vue?vue&type=script&lang=js"
export * from "./CustomerListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports